/**
 * @generated SignedSource<<ae8aed3b6d273df4fc255597680ab90b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateDateEffectiveExchangeRatesInput = {
  currency: string;
  rates: ReadonlyArray<RateEntryInput>;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type RateEntryInput = {
  rate: number;
  startDate: string;
};
export type CreateExchangeRateBatchMutation$variables = {
  input: CreateDateEffectiveExchangeRatesInput;
};
export type CreateExchangeRateBatchMutation$data = {
  readonly createDateEffectiveExchangeRates: {
    readonly company: {
      readonly id: string;
      readonly exchangeRates: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly currency: string | null;
            readonly rate: number | null;
            readonly startDate: string | null;
            readonly endDate: string | null;
            readonly isUsed: boolean | null;
            readonly createdAt: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type CreateExchangeRateBatchMutation = {
  variables: CreateExchangeRateBatchMutation$variables;
  response: CreateExchangeRateBatchMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ExchangeRateTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExchangeRate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isUsed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateExchangeRateBatchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateDateEffectiveExchangeRatesPayload",
        "kind": "LinkedField",
        "name": "createDateEffectiveExchangeRates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": "exchangeRates",
                "args": null,
                "concreteType": "ExchangeRateTypeConnection",
                "kind": "LinkedField",
                "name": "__Company_exchangeRates_connection",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateExchangeRateBatchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateDateEffectiveExchangeRatesPayload",
        "kind": "LinkedField",
        "name": "createDateEffectiveExchangeRates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "ExchangeRateTypeConnection",
                "kind": "LinkedField",
                "name": "exchangeRates",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": "exchangeRates(first:10000)"
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Company_exchangeRates",
                "kind": "LinkedHandle",
                "name": "exchangeRates"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6c485e6d5182abc1820673c505ae4cd6",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "createDateEffectiveExchangeRates",
            "company",
            "exchangeRates"
          ]
        }
      ]
    },
    "name": "CreateExchangeRateBatchMutation",
    "operationKind": "mutation",
    "text": "mutation CreateExchangeRateBatchMutation(\n  $input: CreateDateEffectiveExchangeRatesInput!\n) {\n  createDateEffectiveExchangeRates(input: $input) {\n    company {\n      id\n      exchangeRates(first: 10000) {\n        edges {\n          node {\n            id\n            currency\n            rate\n            startDate\n            endDate\n            isUsed\n            createdAt\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "817113836f1cf63e1cf0f7c0a88ac40e";

export default node;
